import { StyledFooter } from './style';
import { useIntl } from 'react-intl';
import { Icon } from 'ui';
import { links, policyLinks } from 'config/config';

interface ContactContent {
  icon: string;
  content: string;
}

const contactContent: ContactContent[] = [
  { icon: 'bank-icon', content: 'footer.bank' },
  { icon: 'location-tick-icon', content: 'footer.location-tick' },
  { icon: 'call-calling-icon', content: 'footer.call-calling' },
  { icon: 'sms-tracking-icon', content: 'footer.sms-tracking' },
];

const DefaultFooter = () => {
  const intl = useIntl();
  const copyrightText = intl.formatMessage({ id: 'footer.copyright' });

  return (
    <StyledFooter>
      <div className="container">
        <div className={'footer-contacts'}>
          <div className="footer-title">
            <p>{intl.formatMessage({ id: 'general.contacts' })}</p>
            <div className={'footer-icon-wrapper'}>
              <Icon
                name={'twitter'}
                type={'card'}
                url={{
                  href: links['facebook'],
                  target: '_blank',
                }}
              />
              <Icon
                name={'youtube'}
                type={'card'}
                url={{
                  href: links['youtube'],
                  target: '_blank',
                }}
              />
              <Icon
                name={'instagram'}
                type={'card'}
                url={{
                  href: links['instagram'],
                  target: '_blank',
                }}
              />
            </div>
          </div>
          <div className={'footer-content-wrapper'}>
            {contactContent.slice(0, 2).map((content, index) => (
              <div className={'footer-content-container'} key={index}>
                <Icon
                  name={content.icon}
                  type={'avarage'}
                  className="contact-icon"
                />
                <div className={'footer-content'}>
                  {content.content === 'footer.location-tick' ? (
                    intl
                      .formatMessage({ id: content.content })
                      .split('\n')
                      .map((line, index) => <p key={index}>{line}</p>)
                  ) : (
                    <p>{intl.formatMessage({ id: content.content })}</p>
                  )}
                </div>
              </div>
            ))}

            <div className="footer-content-container-right">
              {contactContent.slice(2, 4).map((content, index) => {
                const isPhone = content.content === 'footer.call-calling';
                const text = intl.formatMessage({ id: content.content });

                return (
                  <div className={'footer-content-container'} key={index}>
                    <Icon
                      name={content.icon}
                      type={'avarage'}
                      className="contact-icon"
                    />
                    <div className={'footer-content'}>
                      {isPhone ? (
                        <a href={`tel:${text.replace(/\s+/g, '')}`}>
                          <p>{text}</p>
                        </a>
                      ) : (
                        <a
                          href={`mailto:${intl.formatMessage({
                            id: `${content.content}`,
                          })}`}
                        >
                          {intl.formatMessage({ id: `${content.content}` })}
                        </a>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className={'desktop-footer-image-wrapper'}>
        <div className={'footer-desktop-print'} />
      </div>
      <div className="footer-copyright">
        <div className="container">
          <div className="copyright-text">
            <p dangerouslySetInnerHTML={{ __html: copyrightText }} />
          </div>
          <div className="policies">
            <a
              href={policyLinks['cookiePolicy']}
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({ id: 'policy.cookie_policy' })}
            </a>
            <a
              href={policyLinks['privacyPolicy']}
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({ id: 'policy.privacy_policy' })}
            </a>
            <a
              href={policyLinks['termsOfUse']}
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({ id: 'policy.terms_of_use' })}
            </a>
          </div>
        </div>
      </div>
      <div className="mobile-footer-image-wrapper">
        <Icon name={'mobile-footer-print'} type={'footerMobile'} />
        <Icon name={'mobile-footer-print'} type={'footerMobile'} />
      </div>
    </StyledFooter>
  );
};

export default DefaultFooter;
